import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/signature', component: List, name: 'signature.index'},
  {path: '/signature/store', component: Form, name: 'signature.store'},
  {path: '/signature/:id', component: Form, name: 'signature.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/signature/routes.js